import { GET_ADDCOMPLIANCE_REQUESTED, GET_ADDONBOARD_COMPLIANCE_REQUESTED, GET_APPROVECOMPLIANCE_REQUESTED, GET_COMPLIANCE_REQUESTED, GET_CONFIGCOMPLIANCE_REQUESTED, GET_COPMLIANCEVALIDATION, GET_ONBOARD_COMPLIANCE_REQUESTED, GET_UPDATECOMPLIANCE_REQUESTED } from "resources/actionTypes";

export function getCompliance(data) {
  return {
    type: GET_COMPLIANCE_REQUESTED,
    payload: data
  };
}

export function getConfigCompliance(data) {
  return {
    type: GET_CONFIGCOMPLIANCE_REQUESTED,
    payload: data
  };
}

export function approveCompliance(userApproveCompliance) {
  const data ={
    userApproveCompliance:userApproveCompliance,
  }
  return {
    type: GET_APPROVECOMPLIANCE_REQUESTED,
    payload: data,
  };
}

export function getOnBoardCompliance(userOnBoardCompliance) {
  const data ={
    userOnBoardCompliance:userOnBoardCompliance,
  }
  return {
    type: GET_ONBOARD_COMPLIANCE_REQUESTED,
    payload: data,
  };
}

export function postAddCompliance(userAddCompliance) {
  const data ={
    userAddCompliance:userAddCompliance,
  }
  return {
    type: GET_ADDCOMPLIANCE_REQUESTED,
    payload: data,
  };
}

export function postUpdateCompliance(userUpdateCompliance) {
  const data ={
    userUpdateCompliance:userUpdateCompliance,
  }
  return {
    type: GET_UPDATECOMPLIANCE_REQUESTED,
    payload: data,
  };
}

export function postAddOnBoardCompliance(userAddOnBoardCompliance) {
  const data ={
    userAddOnBoardCompliance:userAddOnBoardCompliance,
  }
  return {
    type: GET_ADDONBOARD_COMPLIANCE_REQUESTED,
    payload: data,
  };
}

export function getComplianceValidation() {
  return {
    type: GET_COPMLIANCEVALIDATION.GET_COPMLIANCEVALIDATION_REQUESTED
  };
}